import { defineStore, acceptHMRUpdate } from 'pinia'
import { useAlertStore, useUserStore } from './index'
export const useWsStore = defineStore(
  'websocket',
  () => {
    /**
     * ws 对象
     */
    const socketTask = ref()
    /**
     * 存放从后端接收到的websocket数据
     */
    const dataInfo = ref()
    const url = ref() //url是websocket连接ip
    let isConnected = false //是否已连接
    let isMustClose = false //是否手动断开
    let lockReconnect = false //避免重复连接
    //心跳检测
    let timeout = 50000 //多少毫秒执行检测
    let timeoutObj = null //检测服务器端是否还活着
    let reconnectTimeOutObj = null //重连之后多久再次重连
    let networkStatus = true //网络是否可用
    let networkTimer = null //网络状态检测
    //重连次数
    const reconnectNum = 2
    //已重试次数
    const isReconnectNum = ref(0)
    const alert = useAlertStore()
    const user = useUserStore()
    /**
     * 初始化ws 连接
     *
     */
    function init() {
      if (isConnected) {
        return
      }
      // #ifdef APP
      const keepAlive = uni.requireNativePlugin('Ba-KeepAliveSuit')
      keepAlive.onKeep(
        {
          title: '油白菜RMS',
          content: '',
        },
        (res) => {
          console.log(res)
        },
      )
      keepAlive.requestIgnoreBattery((res) => {
        console.log(res)
      })
      // #endif
      socketTask.value = uni.connectSocket({
        url: url.value + `_${user.userInfo.userName}_1`,
        success: (res) => {
          console.log('websocket连接成功！', res, url.value)
        },
        fail: (e) => {
          console.log('连接失败', e)
        },
      })
      socketTask.value.onOpen((res) => onOpen(res))
      socketTask.value.onMessage((res) => onMessage(res))
      socketTask.value.onClose((e) => onClose(e))
      socketTask.value.onError((e) => onError(e))
    }

    /**
     * 发送数据
     * @param {*} data
     */
    function send(data) {
      reset()
      if (!isConnected || !socketTask.value) {
        reconnect()
        return
      }
      return new Promise((resolve, reject) => {
        socketTask.value.send({
          data: JSON.stringify(data),
          success: (res) => {
            resolve(res)
          },
          fail: (e) => {
            reject(e)
          },
        })
      })
    }

    /**
     * 手动关闭连接
     * @returns
     */
    function stop() {
      if (!socketTask.value) return
      socketTask.value.close({
        success(res) {
          isMustClose = true
          isConnected = false
          reset()
          console.log('关闭成功', res)
        },
        fail(err) {
          console.log('关闭失败', err)
        },
      })
    }
    /**
     * 连接成功回调
     * @param {*} res
     */
    function onOpen(res) {
      console.log('WebSocket连接正常打开中...！')
      // 清除重连定时器
      clearTimeout(reconnectTimeOutObj)
      isReconnectNum.value = 0
      isConnected = true
      // 开启检测
      start()
    }
    /**
     * 收到信息回调
     * @param {*} res
     */
    function onMessage(res) {
      reset()
      networkStatus = true
      let msg
      try {
        if ((res.data + '').toLowerCase() === 'pong') {
          networkStatus = true
          return
        }
        msg = JSON.parse(res.data)
        dataInfo.value = msg
        uni.$emit('WsOnMessage', msg)
        if (msg.updateKDSFlag) {
          let type = msg.updateKDSFlag === 3 ? 'error' : 'info'
          console.log('收到消息', msg, type)
          //回复服务器确认
          socketTask.value.send({
            data: 'key_' + msg.key,
            success: (res) => {
              console.log('回复服务器确认发送成功', res)
            },
            fail: (err) => {
              console.log('回复服务器确认发送失败', err)
            },
          })
          if (msg.msg && msg.msg !== '') alert.addMessage(msg, true, type)
          // 并台/转台/撤台提醒 —— 统一在此处弹窗，避免多个页面重复弹窗
          if (msg.updateKDSFlag == 4 || msg.updateKDSFlag == 6 || msg.updateKDSFlag == 7) {
            uni.showModal({
              title:
                msg.updateKDSFlag == 4
                  ? '撤台提醒'
                  : msg.updateKDSFlag == 6
                    ? '转台提醒'
                    : '并台提醒',
              content: msg.msg,
              showCancel: false,
            })
          }
          // alert.audioPlay(msg)
        }
      } catch (e) {
        console.log('数据格式错误', e)
      }
    }

    /**
     * 连接关闭回调
     * @param {*} e
     */
    function onClose(e) {
      console.log('WebSocket连接关闭', e)
      isConnected = false
      !isMustClose && reconnect()
    }
    /**
     * 连接错误回调
     * @param {*} e
     */
    function onError(e) {
      console.log('WebSocket连接错误')
      isMustClose = false
      isConnected = false
      !isMustClose && reconnect()
    }
    /**
     * reset和start方法主要用来控制心跳的定时。
     */
    function reset() {
      // 清除定时器重新发送一个心跳信息
      clearTimeout(timeoutObj)
      clearTimeout(networkTimer)
      start()
    }
    /**
     * 开始心跳检测
     */
    function start() {
      timeoutObj = setTimeout(() => {
        //这里发送一个心跳，后端收到后，返回一个心跳消息，
        //onmessage拿到返回的心跳就说明连接正常
        socketTask.value.send({
          data: 'ping',
          success: (res) => {
            networkStatus = false
            networkStatusChange()
          },
          fail: (err) => {
            console.log('心跳检测错误', err)
            isConnected = false
            stop()
            reconnect()
          },
        })
      }, timeout)
    }
    /**
     * 网络检测
     */
    function networkStatusChange() {
      networkTimer = setTimeout(() => {
        if (!networkStatus) {
          console.log('网络断开！')
          isConnected = false
          stop()
          reconnect()
        }
      }, 15000)
    }
    /**
     * 重连
     */
    function reconnect() {
      // 防止多个方法调用，多处重连
      if (lockReconnect) {
        return
      }
      lockReconnect = true

      console.log('准备重连---' + isReconnectNum.value)
      isReconnectNum.value++

      //没连接上会一直重连，设置延迟避免请求过多
      reconnectTimeOutObj = setTimeout(() => {
        // 重新连接
        init()
        lockReconnect = false
      }, 2000)
    }

    return {
      socketTask,
      dataInfo,
      url,
      init,
      send,
      stop,
      reset,
    }
  },
  { persist: false },
)

// 确保传递正确的 store 声明
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useWsStore, import.meta.hot))
}
